module.exports = __webpack_public_path__ + "img/poster.d97727dd.jpg";